import { FC, useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getEmployees, resetLoading } from "app/features/reportsSlice";
import withAuth from "lib/hoc/withAuth";
import TableLayout from "components/Forms/TableLayout/TableLayout";
import Filters from "./components/Filters";
import Table from "./components/Table";
import { employeesColumns, employeesFileColumns } from "./components/columns";
import { DatasheetReport } from "types";
import { employeeGridMapper } from "lib/helpers/reportsHelper";
import { exportToXLSX } from "lib/helpers/convertToXLS";

const Employees: FC = () => {
  const dispatch = useAppDispatch();
  const { employees, loading } = useAppSelector((state) => state.reports);
  const [loadingFile, setLoadingFile] = useState(false);

  const handleSelect = (payload: DatasheetReport) => {
    dispatch(getEmployees(payload));
  };

  useEffect(() => {
    dispatch(resetLoading());
  }, []);

  function handleExportFile() {
    setLoadingFile(true);
    setTimeout(() => {
      const data = employeeGridMapper(employees);
      const filename = "Colaboradores.xlsx";
      exportToXLSX(data, employeesFileColumns, filename);
      setLoadingFile(false);
    }, 1000);
  }

  return (
    <TableLayout maxWidthCard={1600} maxWidthContainer='xl' title='Colaboradores'>
      <Filters
        isLoading={loading}
        loadingFile={loadingFile}
        handleSelect={handleSelect}
        handleExportFile={handleExportFile}
        isButtonEnabled={!employees?.length}
      />
      <Table
        isLoading={loading}
        dataGridColumns={employeesColumns}
        rows={employeeGridMapper(employees)}
        fileName='Colaboradores'
      />
    </TableLayout>
  );
};

export default withAuth(Employees);
